/**
 * Billing React Query hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client';
import { authKeys } from './useAuthQueries';

export const billingKeys = {
    all: ['billing'] as const,
    invoices: () => [...billingKeys.all, 'invoices'] as const,
};

/** Upgrade user plan (simulated) */
export function useUpgradePlan() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async (plan: 'pro' | 'enterprise') => {
            return await apiClient.post('/billing/upgrade', { plan });
        },
        onSuccess: () => {
            // Invalidate user data to reflect tier change
            queryClient.invalidateQueries({ queryKey: authKeys.currentUser });
            queryClient.invalidateQueries({ queryKey: billingKeys.invoices() });
        },
    });
}

/** Fetch user invoice history */
export function useInvoices() {
    return useQuery({
        queryKey: billingKeys.invoices(),
        queryFn: async () => {
            return await apiClient.get<any[]>('/billing/invoices');
        },
    });
}
